import { Box } from '@mui/material'
import { FC } from 'react'

interface SuggestionErrorProps {
  error: string;
}

export const SuggestionError:FC<SuggestionErrorProps> = ({error}) => {
  return (

      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          fontWeight: 500,
          p:2,
          minWidth:'100%',
        }}
      >
        {error}
      </Box>

  )
}